import type { JSX } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { component$, useContext } from '@builder.io/qwik';
import type { COLOR } from '~/types/AppData/Theme/ColorInterface';
import SearchIcon from '~/icons/search';
import { getCSSColorSVGStroke } from '~/utilities/getCSS';
import { AppDataContext } from '~/contexts/AppDataContext';

const iconClasses = cva('', {
  variants: {
    color: getCSSColorSVGStroke(),
  },
});

const SITES_WITH_SEARCH = ['swimsuit.si.com', 'lifestyle.si.com', 'www.si.com'];

export default component$(({ color }: { color: COLOR }): JSX.Element => {
  const {
    payloadToSSR: { propertyEndpoint, propertySettings },
  } = useContext(AppDataContext);

  const includeSearchIcon = SITES_WITH_SEARCH.find((url) =>
    propertyEndpoint?.includes(url)
  );

  const baseUrl = propertySettings.isFannation
    ? 'www.si.com/fannation'
    : propertyEndpoint;

  return (
    <>
      {includeSearchIcon && (
        <a class={iconClasses({ color })} href={`https://${baseUrl}/search`}>
          <SearchIcon />
        </a>
      )}
    </>
  );
});
